import styled from "styled-components";

export const StyledInputGroup = styled.div`
  margin-bottom: 24px;
  text-align: center;
  margin-top: 30px;
  label {
    display: inline-block;
    margin-bottom: 0.5rem;
  }
`;
